// @flow
import * as React from 'react'

import { Navigation } from '@toggl/ui'

export function Careers() {
  return (
    <Navigation.DropdownItem item="careers">
      <span>Careers</span>
      <Navigation.DropdownColumn title="Work on a product that matters to millions">
        <Navigation.LinkWithIcon
          link="/jobs/"
          imageLink={require('components/layouts/assets/icon-jobs.svg')}
          imageAlt="Icon: Magnifying glass zoning in on a lightning bolt"
          title="Current job openings"
          description="We are hiring! Apply by taking a skills test; no resume or CV required"
        />

        <Navigation.LinkWithIcon
          link="/track/culture/"
          imageLink={require('components/layouts/assets/icon-culture.svg')}
          imageAlt="Icon: A crown with Toggl's icon on it"
          title="The Toggl Track Culture"
          description="Learn more about our mission, vision and values"
        />
      </Navigation.DropdownColumn>
    </Navigation.DropdownItem>
  )
}
